import { PbxHttpClient } from "@/services/httpclient";

const state = {
  allBreaks: [],
  activeBreak: {},
  adminBreaksLock: [],
  adminBreaksUnlock: [],
};

const getters = {
  GET_ALL_BREAKS(state) {
    return state.allBreaks;
  },
  GET_IS_BREACK_ACTIVE(state) {
    return Object.keys(state.activeBreak) == 0 ? false : true;
  },
  GET_BREAK(state) {
    return state.activeBreak;
  },
  GET_BREAK_LOCK(state) {
    return state.adminBreaksLock;
  },
  GET_BREAK_UNLOCK(state) {
    return state.adminBreaksUnlock;
  },
};

const mutations = {
  SET_ALL_BREAKS(state, payload) {
    state.allBreaks = payload;
  },

  PUSH_BREAKS: (state, payload) => {
    const value = state.allBreaks.find((element) => {
      return element.id === payload.id;
    });
    if (value === undefined) {
      state.allBreaks.push(payload);
    }
  },

  UPDATE_BREAKS: (state, payload) => {
    const indexupdate = state.allBreaks
      .map((element) => {
        return element.id;
      })
      .indexOf(payload.id);
    if (indexupdate > -1) {
      state.allBreaks.splice(indexupdate, 1, payload);
    }
  },

  DELETE_USER: (state, payload) => {
    const indexdelete = state.allBreaks
      .map((element) => {
        return element.id;
      })
      .indexOf(payload);
    if (indexdelete > -1) {
      state.allBreaks.splice(indexdelete, 1);
    }
  },

  SET_ACTIVE_BREAK: (state, payload) => {
    state.activeBreak = payload;
  },

  SET_ADMIN_BREAKS_LOCK: (state, payload) => {
    state.adminBreaksLock = payload;
  },

  SET_ADMIN_BREAKS_UNLOCK: (state, payload) => {
    state.adminBreaksUnlock = payload;
  },
};

const actions = {
  async REGISTER_BREAKS({ state, commit }, payload) {
    try {
      const response = await PbxHttpClient.post("/clients/pause", payload);
      commit("PUSH_BREAKS", response.data.pause);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_BREAKS({ commit }) {
    try {
      const response = await PbxHttpClient.get("/clients/pause");
      commit("SET_ALL_BREAKS", response.data.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_BREAKS_AGENTS({ commit }) {
    try {
      const response = await PbxHttpClient.get("/agent/show_Pause_agente");
      commit("SET_ALL_BREAKS", response.data.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async EDIT_BREAKS({ commit }, { data, id }) {
    try {
      const response = await PbxHttpClient.put(`/clients/pause/${id}`, data);
      commit("UPDATE_BREAKS", response.data.pause);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DELETE_BREAKS({ commit }, payload) {
    try {
      const response = await PbxHttpClient.delete(`/clients/pause/${payload.id}`);
      commit("DELETE_USER", payload.id);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async USE_BREAK({ commit }, payload) {
    try {
      const response = await PbxHttpClient.post(`/agent/use_pause/`, payload);
      commit("SET_ACTIVE_BREAK", response.data.pause);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async CONTINUE_SESSION({ commit }, payload) {
    try {
      const response = await PbxHttpClient.put(`/agent/use_pause/${payload.id}`);
      commit("SET_ACTIVE_BREAK", {});
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_AGENTS_BREAKS_LOCK({ commit }, payload) {
    try {
      const response = await PbxHttpClient.get(`/admin/lock_user/`);
      commit("SET_ADMIN_BREAKS_LOCK", response.data.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async UNLOCK_AGENTS({ commit }, payload) {
    try {
      const response = await PbxHttpClient.put(
        `/admin/unlock_user/${payload.id}`,
        payload.comment
      );
      commit("SET_ADMIN_BREAKS_LOCK", response.data.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_AGENTS_BREAKS_UNLOCK({ commit }, payload) {
    try {
      const response = await PbxHttpClient.get(`/admin/unlock_user/`);
      commit("SET_ADMIN_BREAKS_UNLOCK", response.data.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// Exportar Clientes
export const breaks = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
